function truncateHTMLContent(selector = '.pro-description', wordLimit = 19) {
  $(selector).each(function () {
    const $el = $(this);
    if ($el.data('truncated')) return;

    const fullHtml = $el.html().trim();
    const tempDiv = $("<div>").html(fullHtml);
    let wordCount = 0;
    let visibleHtml = "", hiddenHtml = "";

    const processNode = (node) => {
      if (wordCount >= wordLimit) {
        hiddenHtml += node.outerHTML || node.textContent;
        return;
      }

      if (node.nodeType === 3) {
        const words = node.textContent.trim().split(/\s+/);
        if (!words.length) return;

        if (wordCount + words.length <= wordLimit) {
          visibleHtml += node.textContent;
          wordCount += words.length;
        } else {
          const cut = wordLimit - wordCount;
          visibleHtml += words.slice(0, cut).join(" ") + " ";
          hiddenHtml += words.slice(cut).join(" ") + " ";
          wordCount = wordLimit;
        }
      } else if (node.nodeType === 1) {
        const tag = node.tagName.toLowerCase();
        const attrs = [...node.attributes].map(a => ` ${a.name}="${a.value}"`).join("");
        const open = `<${tag}${attrs}>`, close = `</${tag}>`;

        let childVisible = "", childHidden = "";

        $(node).contents().each(function () {
          const before = wordCount;
          const prevVis = visibleHtml, prevHid = hiddenHtml;
          visibleHtml = "", hiddenHtml = "";
          processNode(this);
          childVisible += visibleHtml;
          childHidden += hiddenHtml;
          visibleHtml = prevVis;
          hiddenHtml = prevHid;
        });

        if (childVisible) visibleHtml += open + childVisible + close;
        if (childHidden) hiddenHtml += open + childHidden + close;
      }
    };

    tempDiv.contents().each(function () {
      processNode(this);
    });

    if (wordCount >= wordLimit) {
      $el.html(`
        ${visibleHtml}<span class="dots">...</span>
        <span class="more-text" style="display:none;">${hiddenHtml}</span>
        <a href="#" class="read-more-toggle" style="cursor:pointer;"> Read more</a>
      `);

      $el.data('truncated', true); // Mark this element as processed
    }
  });
}

$(document).on("click", ".read-more-toggle", function (e) {
  e.preventDefault();
  const $t = $(this);
  const $p = $t.closest(".product-info__block-item");

  $p.find(".more-text, .dots").toggle(200);
  
  if ($t.text().trim() === "Read more") {
    $t.text(" Read less");
  } else {
    $t.text(" Read more");
  }
});

$(document).ready(function () {
  const $body = $('body');
     truncateHTMLContent();
});

document.querySelectorAll('.prtab').forEach((prTab, idx) => {
    prTab.addEventListener('click', function() {
        document.querySelectorAll('.prtab').forEach(tab => tab.classList.remove('active'));
        document.querySelectorAll('.bmtabcontent').forEach(content => content.classList.remove('active'));

        prTab.classList.add('active');
        document.querySelector(`.bmtabcontent[data-id="prt-${idx + 1}"]`).classList.add('active');
    });
});
document.querySelector('.prtab')?.classList.add('active');
document.querySelector('.bmtabcontent')?.classList.add('active');

document.querySelectorAll('variant-picker').forEach(picker => {
  picker.querySelectorAll('input[name="option1"]').forEach(input => {
    input.addEventListener('change', () => {
      const selectedOption1 = picker.querySelector('input[name="option1"]:checked').value;
      const option2Elements = picker.querySelectorAll('.variant-picker__custom-option[data-pack]');

      // Normalize selectedOption1 for comparison (remove spaces, lowercase)
      const normalizedSelectedOption1 = selectedOption1.replace(/\s+/g, '').toLowerCase();

      // Update variant picker elements
      option2Elements.forEach(option => {
        const pack = option.getAttribute('data-pack');
        const variantData = picker.querySelector(`.variant-list [data-flavor="${selectedOption1}"][data-pack="${option.querySelector('input[name="option2"]').value}"]`);

        if (variantData) {
          // Update image
          const imageElement = option.querySelector('.variant-picker__image');
          const newImage = variantData.getAttribute('data-img');
          if (imageElement && newImage) {
            imageElement.src = newImage;
            imageElement.style.display = 'block';
          } else if (imageElement) {
            imageElement.style.display = 'none';
          }

          // Update price
          const priceElement = option.querySelector('.variant-picker__price');
          if (priceElement) {
            priceElement.textContent = variantData.getAttribute('data-price');
          }

          // Update compare-at price
          const comparePriceElement = option.querySelector('.variant-picker__compare-price');
          const newComparePrice = variantData.getAttribute('data-comprice');
          if (comparePriceElement && newComparePrice) {
            comparePriceElement.textContent = newComparePrice;
            comparePriceElement.style.display = 'inline';
          } else if (comparePriceElement) {
            comparePriceElement.style.display = 'none';
          }

          // Update discount
          const discountElement = option.querySelector('.variant-picker__discount');
          const newDiscount = variantData.getAttribute('data-discount');
          if (discountElement && newDiscount && parseInt(newDiscount) > 0) {
            discountElement.textContent = `${newDiscount}% off`;
            discountElement.style.display = 'inline';
          } else if (discountElement) {
            discountElement.style.display = 'none';
          }

          // Update form input (for Add to Cart)
          const form = picker.querySelector(`form[id="${picker.getAttribute('form')}"]`);
          const selectedOption2 = option.querySelector('input[name="option2"]:checked')?.value || variantData.getAttribute('data-pack');
          const selectedVariant = picker.querySelector(`.variant-list [data-flavor="${selectedOption1}"][data-pack="${selectedOption2}"]`);
          if (form && selectedVariant) {
            const variantId = Array.from(document.querySelectorAll('select[name="id"] option')).find(option => 
              option.textContent.includes(`${selectedOption1} / ${selectedOption2}`)
            )?.value;
            if (variantId) {
              const formInput = form.querySelector('input[name="id"]') || document.createElement('input');
              if (!formInput.parentNode) {
                formInput.type = 'hidden';
                formInput.name = 'id';
                form.appendChild(formInput);
              }
              formInput.value = variantId;
            }
          }
        }
      });

      // Update product gallery thumbnails
      const galleryThumbnails = document.querySelectorAll('.product-gallery__thumbnail');
      galleryThumbnails.forEach((button, index) => {
        const altImage = button.getAttribute('data-alt-image');
        const normalizedAltImage = altImage ? altImage.replace(/\s+/g, '').toLowerCase() : '';
        if (normalizedAltImage && normalizedAltImage === normalizedSelectedOption1) {
          button.removeAttribute('hidden');
          // Set the first matching thumbnail as active
          button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
        } else {
          button.setAttribute('hidden', '');
        }
      });

      // Update product gallery media elements
      const galleryMedia = document.querySelectorAll('.product-gallery__media');
      galleryMedia.forEach((media, index) => {
        const altImage = media.getAttribute('data-alt-image');
        const normalizedAltImage = altImage ? altImage.replace(/\s+/g, '').toLowerCase() : '';
        if (normalizedAltImage && normalizedAltImage === normalizedSelectedOption1) {
          media.removeAttribute('hidden');
          // Set the first matching media as initial
          media.classList.toggle('is-initial', index === 0);
        } else {
          media.setAttribute('hidden', '');
          media.classList.remove('is-initial');
        }
      });

      // Ensure at least one thumbnail and media is visible (fallback to default)
      const hasVisibleThumbnails = Array.from(galleryThumbnails).some(button => !button.hasAttribute('hidden'));
      const hasVisibleMedia = Array.from(galleryMedia).some(media => !media.hasAttribute('hidden'));
      if (!hasVisibleThumbnails && galleryThumbnails.length > 0) {
        galleryThumbnails[0].removeAttribute('hidden');
        galleryThumbnails[0].setAttribute('aria-current', 'true');
      }
      if (!hasVisibleMedia && galleryMedia.length > 0) {
        galleryMedia[0].removeAttribute('hidden');
        galleryMedia[0].classList.add('is-initial');
      }

      // Refresh carousel if applicable (e.g., for Swiper)
      const swiper = document.querySelector('.product-gallery__thumbnail-scroller')?.swiper;
      if (swiper) swiper.update();
    });
  });

  // Trigger initial update for default selection
  const defaultOption1 = picker.querySelector('input[name="option1"]:checked');
  if (defaultOption1) {
    defaultOption1.dispatchEvent(new Event('change'));
  }
});

document.addEventListener("DOMContentLoaded", function() {
    var tabContent = document.querySelector('.bmtabcontent.is-3');
    var popupBlock = document.querySelector('.popup-block');
    var closeIcon = document.querySelector('.popup-wrap .close_icon, .popup-wrap [data-close], .popup-wrap svg');

    if (tabContent) {
        var text = tabContent.innerHTML;
        var words = text.split(/\s+/);
        if (words.length > 30) {
            var shortText = words.slice(0, 30).join(' ') + '... ';
            tabContent.innerHTML = shortText + '<a href="#" class="read-more-link">Read more</a>';
            tabContent.querySelector('.read-more-link').addEventListener('click', function(e) {
                e.preventDefault();
                popupBlock.style.display = 'block';
            });
        }
    }

    if (popupBlock) {
        popupBlock.style.display = 'none';
    }

    if (closeIcon) {
        closeIcon.addEventListener('click', function() {
            popupBlock.style.display = 'none';
        });
    }
});